import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import AdminLayout from "../../masterLayout/AdminLayout";
import AdminPageHeader from "../../components/admin/AdminPageHeader";
import AdminDataTable from "../../components/admin/AdminDataTable";
import { adminApi, handleAdminLogoutIfNeeded } from "../../utils/adminApi";

const AdminPages = () => {
  const [pages, setPages] = useState([]);
  const [form, setForm] = useState(null);
  const [msg, setMsg] = useState("");

  const load = async () => {
    const res = await adminApi({ url: "admin/get-all-page", method: "GET" });
    if (handleAdminLogoutIfNeeded(res)) return;
    if (res.success) setPages(res.data || []);
  };

  useEffect(() => {
    document.title = "Admin Pages";
    load().catch(console.error);
  }, []);

  const save = async (e) => {
    e.preventDefault();
    const res = await adminApi({
      url: "admin/add-page",
      method: "POST",
      body: form,
    });
    if (handleAdminLogoutIfNeeded(res)) return;
    setMsg(res.msg || (res.success ? "Added" : "Failed"));
    if (res.success) {
      setForm(null);
      load();
    }
  };

  const del = async (row) => {
    if (!window.confirm("Delete this page?")) return;
    const res = await adminApi({
      url: "admin/del-page",
      method: "POST",
      body: { id: row.id },
    });
    if (handleAdminLogoutIfNeeded(res)) return;
    setMsg(res.msg || (res.success ? "Deleted" : "Failed"));
    if (res.success) load();
  };

  const columns = [
    { key: "id", label: "ID" },
    { key: "title", label: "Title" },
    { key: "slug", label: "Slug" },
    {
      key: "actions",
      label: "Actions",
      render: (_, row) => (
        <button
          type="button"
          className="admin-btn admin-btn-danger"
          style={{ minHeight: 34, padding: "0 10px" }}
          onClick={() => del(row)}
        >
          <Icon icon="lucide:trash-2" width={16} />
        </button>
      ),
    },
  ];

  return (
    <AdminLayout>
      <div className="admin-ui">
        <AdminPageHeader
          title="CMS pages"
          subtitle={`${pages.length} public content pages for the landing site.`}
          action={
            <button
              type="button"
              className="admin-btn admin-btn-primary"
              onClick={() => setForm({ title: "", slug: "", meta: "", content: "" })}
            >
              <Icon icon="lucide:plus" width={18} />
              Add page
            </button>
          }
        />
        {msg ? <div className="admin-alert admin-alert-info">{msg}</div> : null}

        {form && (
          <div className="admin-form-card">
            <div className="admin-form-head">
              <h6>{form.id ? "Edit page" : "New page"}</h6>
              <p>Public CMS content at /page/:slug</p>
            </div>
            <form onSubmit={save}>
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">Title</label>
                  <input
                    className="form-control"
                    value={form.title}
                    onChange={(e) => setForm({ ...form, title: e.target.value })}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Slug</label>
                  <input
                    className="form-control"
                    placeholder="about-us"
                    value={form.slug}
                    onChange={(e) => setForm({ ...form, slug: e.target.value })}
                    required
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">Meta</label>
                  <input
                    className="form-control"
                    value={form.meta}
                    onChange={(e) => setForm({ ...form, meta: e.target.value })}
                    required
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">Content</label>
                  <textarea
                    className="form-control"
                    rows={6}
                    value={form.content}
                    onChange={(e) => setForm({ ...form, content: e.target.value })}
                    required
                  />
                </div>
              </div>
              <div className="admin-form-actions" style={{ marginTop: 16 }}>
                <button type="submit" className="admin-btn admin-btn-primary">Save</button>
                <button type="button" className="admin-btn admin-btn-ghost" onClick={() => setForm(null)}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        )}

        <AdminDataTable columns={columns} rows={pages} />
      </div>
    </AdminLayout>
  );
};

export default AdminPages;
